import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/content";
import { Reveal } from "../motion/Motion";

export default function Services() {
  return (
    <section
      id="szolgaltatasok"
      data-testid="services-section"
      className="relative bg-[#F3F4F6] py-20 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-10 flex flex-col gap-6 md:mb-16 md:flex-row md:items-end md:justify-between">
          <div>
            <Reveal>
              <p className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-brand-accent">
                <span className="h-px w-10 bg-brand-accent" />
                Szolgáltatásaink
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="max-w-2xl font-heading text-3xl font-extrabold leading-[1.08] tracking-tight text-brand-primary sm:text-4xl lg:text-5xl">
                Komplett hőszigetelési megoldások egy kézből
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-base leading-relaxed text-brand-primary/60">
              Három fő szakterületünkkel épülete minden pontján biztosítjuk az optimális
              hővédelmet és energiahatékonyságot.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {SERVICES.map((service, i) => (
            <Reveal key={service.id} delay={i * 0.1}>
              <motion.a
                href={service.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${service.id}`}
                className={`group relative flex h-full flex-col overflow-hidden bg-white shadow-[0_8px_30px_rgba(10,37,64,0.04)] transition-shadow duration-300 hover:shadow-[0_30px_60px_-20px_rgba(10,37,64,0.3)] ${
                  i === 1 ? "md:mt-12" : ""
                }`}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-primary/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                  <span className="absolute left-5 top-5 font-mono text-sm font-medium text-white/90 mix-blend-difference">
                    {service.number}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <h3 className="font-heading text-xl font-bold text-brand-primary lg:text-2xl">
                    {service.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-brand-primary/65">
                    {service.description}
                  </p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand-primary transition-colors group-hover:text-brand-accent">
                    Tudjon meg többet
                    <ArrowUpRight
                      size={16}
                      className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    />
                  </span>
                </div>
              </motion.a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
